const CustomLabelCheckbox = ({ value, ...props }) => {
  return <label {...props}> {value} </label>;
};
export default CustomLabelCheckbox;
